import * as PropTypes from "prop-types"
import styled from "styled-components"
import Typography from "components/styled/Typography"
import Icon from "components/icons/icon"
import SideArrow from "components/icons/sideArrow"

const Li = styled.li`
  display: flex;
`

const StyledIcon = styled(Icon)`
  margin-right: 5px;
`

const Text = styled(Typography)`
  font-size: 11px;
  line-height: 18px;
`

export default function Item({ children }) {
  return (
    <Li>
      <StyledIcon Icon={SideArrow} size="xs" />
      <Text>{children}</Text>
    </Li>
  )
}

Item.propTypes = {
  children: PropTypes.node.isRequired
}
